<template>
  <div>
    <!-- Contact Conformation -->
    <div class="modal-wrap display-none">
      <div class="modal">
        <img src="@/assets/homePage/contact-thank-you.svg" alt="" />
        <p>Thank you for your submission!</p>
        <p>We will be in back in touch in 24-48 hours.</p>
        <button class="btn modal-close">Close</button>
      </div>
    </div>
    <!-- Mobile Navigation -->
    <div class="mobile-background display-none">
      <i class="far fa-times-circle"></i>
      <ul class="mobile-nav">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About Us</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#team">Team</a></li>
        <li><a href="#contact-us">Contact Us</a></li>
      </ul>
    </div>
    <!-- Hero -->
    <section class="hero" id="hero">
      <div class="flex-row container">
        <div class="left">
          <h2>
            We provide <br /><span><u>solutions</u></span
            ><br />for your business!
          </h2>
          <div class="buttons">
            <a href="#contact-us" class="btn">Get Started</a>
            <a href="#services" class="btn btn-light">Our Services</a>
          </div>
        </div>
        <img src="@/assets/homePage/intro-img.svg" alt="" />
      </div>
    </section>
    <!-- About us -->
    <section class="about about-1" id="about">
      <div class="container">
        <h2>About us</h2>
        <div class="flex-row">
          <div class="left">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Necessitatibus libero facere repellendus ipsum
              distinctio velit voluptatibus. Amet quam eligendi impedit cum, nam id inventore quibusdam neque eos, quae
              voluptatibus qui.
            </p>
            <div class="flex-row">
              <i class="fas fa-bullhorn"></i>
              <div class="info">
                <h4>Title #1</h4>
                <p>
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit. Numquam, aliquid ipsam. Illum soluta nam
                  cum?
                </p>
              </div>
            </div>
            <div class="flex-row">
              <i class="fas fa-balance-scale"></i>
              <div class="info">
                <h4>Title #2</h4>
                <p>
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit. Numquam, aliquid ipsam. Illum soluta nam
                  cum?
                </p>
              </div>
            </div>
            <div class="flex-row">
              <i class="fas fa-globe"></i>
              <div class="info">
                <h4>Title #3</h4>
                <p>
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit. Numquam, aliquid ipsam. Illum soluta nam
                  cum?
                </p>
              </div>
            </div>
          </div>
          <div class="right">
            <img src="@/assets/homePage/about-img.svg" alt="" />
          </div>
        </div>
      </div>
    </section>
    <!-- About us #2 -->
    <section class="about about-2">
      <div class="container flex-row">
        <div class="left">
          <img src="@/assets/homePage/about-extra-1.svg" alt="" />
        </div>
        <div class="right">
          <h3>About us secondary content title</h3>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo maxime repudiandae praesentium? Incidunt
            delectus molestiae ipsum? Deleniti in rem sequi.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam harum inventore impedit voluptatum
            fugit eos. Qui unde soluta quis voluptatem?
          </p>
        </div>
      </div>
    </section>
    <!-- About us # 3 -->
    <section class="about about-3">
      <div class="container flex-row">
        <div class="left">
          <h3>About us secondary content title</h3>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam voluptas porro voluptatum saepe molestiae
            ullam ut nobis assumenda sapiente repudiandae.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi tempore dolorum labore accusantium ducimus
            nesciunt quos architecto id dolorem eum?
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut eos illum odit ratione cum similique magnam
            atque culpa consequuntur iusto!
          </p>
        </div>
        <div class="right">
          <img src="img/about-extra-2.svg" alt="" />
        </div>
      </div>
    </section>
    <!-- Services -->
    <section class="services" id="services">
      <div class="container">
        <h2>Services</h2>
        <div class="grid">
          <div class="flex-row">
            <i class="fas fa-mobile-alt pink-text"></i>
            <div class="right">
              <h3>Digital Marketing</h3>
              <p>
                Digital Marketing means everything needed for a traditional advertising campaign, and a lot more. We
                have the vast array of intelligence available to help build target audiences.
              </p>
            </div>
          </div>
          <div class="flex-row">
            <i class="fas fa-globe-americas yellow-text"></i>
            <div class="right">
              <h3>Branding</h3>
              <p>
                Branding is an essential component of successful market. At its core branding means effectively
                identifying your differentiators and value proposition.
              </p>
            </div>
          </div>
          <div class="flex-row">
            <i class="far fa-window-maximize teal-text"></i>
            <div class="right">
              <h3>Web Design</h3>
              <p>
                Colors, typography, imagery and message are hallmarks of good communication. Successful web design
                demands all of this, plus simplicity of navigation, load time, functionality, and usability.
              </p>
            </div>
          </div>
          <div class="flex-row">
            <i class="fas fa-camera-retro green-text"></i>
            <div class="right">
              <h3>Photo & Videography</h3>
              <p>
                Creating a lasting visual impression on a potential customer usually happens with an image first. Be it
                still photography or videography, motion graphics or a compelling combination of all the above.
              </p>
            </div>
          </div>
          <div class="flex-row">
            <i class="fas fa-pencil-ruler limeGreen-text"></i>
            <div class="right">
              <h3>Creative Design</h3>
              <p>
                Skillful use and understanding of type, color, image and sound creates a visual solution that
                communicates a compelling message with a unqiue & modern design for each client.
              </p>
            </div>
          </div>
          <div class="flex-row">
            <i class="fas fa-tablet-alt blue-text"></i>
            <div class="right">
              <h3>Interactive Solutions</h3>
              <p>
                Engagement is a highly valued marketing success metric. Augmented and virtual reality, QR codes, kiosks
                and interactive displays are only some of the ways we have built interactivity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Why -->
    <section class="why">
      <div class="container">
        <h2>Why choose us?</h2>
        <div class="flex-row write-up">
          <div class="col">
            <i class="fas fa-pencil-alt"></i>
            <h3>Design Forward</h3>
            <p>
              Good enough isn't good enough. Top level marketing communications requires state-of-the-art equipment,
              extensive experience, efficient execution and, most importantly, great talent?
            </p>
            <span>Read more</span>
          </div>
          <div class="col">
            <i class="fas fa-signal"></i>
            <h3>Data Driven Decisions</h3>
            <p>
              Demographics, psychographics, audience analysis, ratings & efficiency information, applied psychology,
              archetypes, KPIs-- better information builds the platform upon which better, truer and more compelling
              brand stories can be told.
            </p>
            <span>Read more</span>
          </div>
          <div class="col">
            <i class="fas fa-search"></i>
            <h3>Meticulously Efficient</h3>
            <p>
              A culture of quality intersecting with precision workflow management systems, rigorous oversight and
              tested methodology to deliver desired outcomes.
            </p>
            <span>Read more</span>
          </div>
        </div>
        <div class="flex-row analytics">
          <div class="col">
            <span class="number">274</span>
            <span class="title">Clients</span>
          </div>
          <div class="col">
            <span class="number">421</span>
            <span class="title">Projects</span>
          </div>
          <div class="col">
            <span class="number">1,364</span>
            <span class="title">Hours of Support</span>
          </div>
          <div class="col">
            <span class="number">18</span>
            <span class="title">Hard Workers</span>
          </div>
        </div>
      </div>
    </section>
    <!-- Team -->
    <section class="team" id="team">
      <div class="container">
        <h2>Team</h2>
        <div class="flex-row">
          <div class="col">
            <img src="@/assets/homePage/team-1.jpg" alt="" />
            <div class="bg"></div>
            <div class="info">
              <p>Walter White</p>
              <p>Chief Executive Officer</p>
            </div>
          </div>
          <div class="col">
            <img src="@/assets/homePage/team-2.jpg" alt="" />
            <div class="bg"></div>
            <div class="info">
              <p>Sarah Johnson</p>
              <p>Project Manager</p>
            </div>
          </div>
          <div class="col">
            <img src="@/assets/homePage/team-3.jpg" alt="" />
            <div class="bg"></div>
            <div class="info">
              <p>William Anderson</p>
              <p>CTO</p>
            </div>
          </div>
          <div class="col">
            <img src="@/assets/homePage/team-4.jpg" alt="" />
            <div class="bg"></div>
            <div class="info">
              <p>Amanda Jepsen</p>
              <p>Full Stack Developer</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Clients -->
    <section class="clients">
      <div class="container">
        <h2>Our Clients</h2>
        <div class="flex-row">
          <div class="col">
            <img src="@/assets/homePage/clients/client-1.png" alt="" />
          </div>
          <div class="col">
            <img src="@/assets/homePage/clients/client-2.png" alt="" />
          </div>
          <div class="col">
            <img src="@/assets/homePage/clients/client-3.png" alt="" />
          </div>
          <div class="col">
            <img src="@/assets/homePage/clients/client-4.png" alt="" />
          </div>
          <div class="col">
            <img src="@/assets/homePage/clients/client-5.png" alt="" />
          </div>
          <div class="col">
            <img src="@/assets/homePage/clients/client-6.png" alt="" />
          </div>
          <div class="col">
            <img src="@/assets/homePage/clients/client-7.png" alt="" />
          </div>
          <div class="col">
            <img src="@/assets/homePage/clients/client-8.png" alt="" />
          </div>
        </div>
      </div>
    </section>
    <!-- Contact us -->
    <section class="contact-us" id="contact-us">
      <div class="container">
        <h2>Contact Us</h2>
        <p>Want to work with us on a future project? Fill out the form below to get started!</p>
        <form class="contactForm">
          <div class="flex-row">
            <input class="fullName" type="search" placeholder="Your Name" />
            <input class="emailAddress" type="search" placeholder="Your Email" />
          </div>
          <input class="subject" type="search" placeholder="Subject" />
          <textarea class="message" placeholder="Message"></textarea>
          <button class="btn" type="submit">Send Message</button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
}

a {
  text-decoration: none;
}

h2 {
  font-weight: 500;
  font-size: 36px;
  color: #283d50;
  margin-bottom: 60px;
}

h3 {
  color: #444;
  font-size: 24px;
  margin-bottom: 20px;
}

h4 {
  font-size: 20px;
  margin-bottom: 8px;
  color: #283d50;
}

// animation

@keyframes slide-in {
  0% {
    transform: translateX(300px);
  }

  100% {
    transform: translateX(0);
  }
}
@keyframes slide-out {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(300px);
  }
}

.slide-in {
  animation: slide-in 500ms ease;
}

.slide-out {
  animation: slide-out 500ms ease;
}

// Multiple section styles

.about,
.services,
.why,
.photo-gallery,
.testimonials,
.team,
.clients,
.contact-us,
footer {
  padding: 50px 20px;
  @media (min-width: 900px) {
    padding: 100px 20px;
  }
}

// Modal

.modal-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 4;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  .modal {
    text-align: center;
    padding: 50px;
    border-radius: 8px;
    background-color: #fff;

    img {
      width: 200px;
      height: auto;
      margin-bottom: 16px;
    }

    p:nth-child(2) {
      font-size: 24px;
      margin-bottom: 8px;
    }

    .btn {
      margin-top: 24px;
      &:hover {
        border-color: #007bff;
        color: #007bff;
      }
    }
  }
}

// mobile nav

.mobile-bg {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 4;
  right: 0;

  i {
    position: absolute;
    color: #fff;
    left: 20px;
    top: 20px;
    font-size: 24px;
  }

  ul {
    position: absolute;
    padding: 20px;
    width: 300px;
    right: 0;
    background-color: rgba(0, 123, 255, 0.7);
    height: 100%;

    a {
      color: #fff;
      font-weight: 500;
    }

    li {
      padding: 10px 0;
    }
  }
}

// nav

header {
  height: 79px;
  position: fixed;
  width: 100%;
  z-index: 3;
  background-color: #fff;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.3);

  nav {
    display: flex;
    align-items: center;
    padding: 25px 10px;

    img {
      height: 25px;
    }

    i {
      z-index: 6;
      font-size: 24px;
      flex: 1;
      text-align: right;
      @media (min-width: 800px) {
        display: none !important;
      }
    }

    ul {
      flex: 1;
      justify-content: flex-end;
      display: none;
      @media (min-width: 800px) {
        display: flex;
      }

      a {
        color: #004289;
        font-size: 14px;
        font-weight: 500;
        padding: 0 15px;
        margin-left: 15px;
      }
    }
  }
}

// hero

.hero {
  padding: 150px 0;
  background: url("../assets/homePage/intro-bg.png") center bottom no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;

  .flex-row {
    padding: 0 32px;
    gap: 32px;
    flex-direction: column;
    align-items: center;
    @media (min-width: 1000px) {
      flex-direction: row;
    }
  }

  h2 {
    color: #fff;
    font-size: 40px;
    margin-bottom: 32px;
    text-align: center;
    @media (min-width: 1000px) {
      text-align: initial;
      font-size: 48px;
    }
  }

  .left {
    flex: 1;
    order: 2;
    justify-content: center;
    align-items: center;
    @media (min-width: 1000px) {
      order: 1;
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: 1000px) {
      flex-direction: row;
    }

    .btn {
      text-align: center;
      width: 200px;
      margin-bottom: 16px;
      @media (min-width: 1000px) {
        margin-right: 16px;
      }
    }
  }

  img {
    display: flex;
    flex: 1;
    order: 1;
    width: 50%;
    @media (min-width: 1000px) {
      order: 2;
    }
  }
}

// about us

.about {
  img {
    width: 60%;
    @media (min-width: 900px) {
      width: 100%;
    }
  }

  h2 {
    text-align: center;
  }

  p {
    line-height: 1.7;
  }

  .flex-row {
    gap: 50px;
    flex-direction: column;
    @media (min-width: 900px) {
      flex-direction: row;
    }
  }

  .left,
  .right {
    flex: 1;
  }

  .left {
    .flex-row {
      gap: 0;
      flex-direction: column;
      margin-top: 32px;
      align-items: center;
      @media (min-width: 500px) {
        flex-direction: row;
      }
    }

    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
      @media (min-width: 500px) {
        margin-top: 0;
        align-items: initial;
      }

      p {
        color: #444;
        font-size: 14px;
      }
    }
    i {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 70px;
      border: 2px solid #007bff;
      border-radius: 50%;
      transition: 500ms ease all;
      color: #007bff;
      font-size: 24px;
      @media (min-width: 500px) {
        margin-right: 16px;
      }

      &:hover {
        background-color: #007bff;
        border-color: transparent;
        color: #fff;
      }
    }
  }
}

.about-1 {
  .left {
    text-align: center;
    @media (min-width: 500px) {
      text-align: initial;
    }
  }
}

.about-1,
.about-3 {
  .right {
    display: flex;
    justify-content: center;
    @media (min-width: 900px) {
      align-items: start;
    }
  }
}

.about-2 {
  .left {
    order: 2;
    display: flex;
    justify-content: center;
    @media (min-width: 900px) {
      order: 1;
      align-items: start;
    }
  }

  .right {
    order: 1;
    @media (min-width: 900px) {
      order: 2;
    }
  }
}

.about-2,
.about-3 {
  p {
    margin-bottom: 20px;
  }
}

// services

.services {
  background-color: #ecf5ff;

  .container {
    max-width: 900px;
  }

  h2 {
    text-align: center;
  }

  .grid {
    max-width: 600px;
    margin: 0 auto;
    grid-template-columns: 1fr;
    gap: 32px;
    row-gap: 50px;
    @media (min-width: 800px) {
      grid-template-columns: repeat(2, 1fr);
      max-width: 100%;
    }
  }

  .flex-row {
    cursor: pointer;
    box-shadow: 0 10px 29px 0 rgba(68, 88, 144, 0.1);
    border-radius: 12px;
    position: relative;
    overflow: hidden;
    padding: 30px;
    background-color: #fff;
    transition: 500ms ease all;

    &:hover {
      transform: translateY(-4px);
    }

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 14px;
      line-height: 1.7;
    }

    i {
      font-size: 64px;
      position: absolute;
      left: -10px;
      display: flex;
      align-self: center;
    }

    .right {
      margin-left: 40px;
    }
  }
}

// why

.why {
  background-color: #004a99;
  color: #fff;

  h2,
  h3 {
    color: #fff;
    text-align: center;
  }

  .flex-row {
    margin-top: 60px;
    gap: 60px;
  }

  .write-up {
    margin: 0 auto;
    max-width: 600px;
    flex-direction: column;
    @media (min-width: 900px) {
      max-width: 100%;
      flex-direction: row;
    }

    .col {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      cursor: pointer;
      padding: 40px;
      border-radius: 12px;
      background-color: #00458f;
      text-align: center;
      transition: 500ms ease all;

      &:hover {
        background-color: #003b7a;

        span {
          border-color: #004a99;
        }
      }
    }

    span {
      max-width: 100%;
      margin-top: auto;
      padding-bottom: 4px;
      border-bottom: 2px solid transparent;
    }

    i {
      font-size: 50px;
    }

    h3 {
      margin: 16px 0;
    }

    p {
      font-size: 14px;
      margin-bottom: 32px;
    }
  }

  .analytics {
    flex-direction: column;
    margin-top: 90px;
    justify-content: space-evenly;
    align-items: center;
    @media (min-width: 700px) {
      flex-direction: row;
    }

    span {
      display: block;
      text-align: center;
    }

    .number {
      font-size: 50px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    .title {
      font-size: 14px;
    }
  }
}

// photo gallery

.photo-gallery {
  h2 {
    text-align: center;
  }

  .grid {
    grid-template-columns: 1fr;
    grid-auto-rows: 125px;
    gap: 16px;
    @media (min-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 900px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  // defaults for photo gallery items
  .col {
    position: relative;

    img {
      position: relative;
      object-fit: cover;
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 12px;
    }

    .bg {
      border-radius: 12px;
      transition: 500ms ease all;
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
    }

    .content {
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transition: 500ms ease all;
      opacity: 0;
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;

      p:nth-child(1) {
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 4px;
      }

      p:nth-child(2) {
        margin-bottom: 4px;
      }

      i {
        cursor: pointer;
        font-size: 18px;
        padding: 10px;
        border-radius: 50%;
        background-color: #004289;
      }
    }

    &:hover {
      .bg {
        background-color: rgba(0, 59, 122, 0.7);
      }

      .content {
        opacity: 1;
      }
    }
  }

  .photo-1 {
    grid-row: span 3;
  }

  .photo-2,
  .photo-6,
  .photo-7,
  .photo-8,
  .photo-9 {
    grid-row: span 2;
  }

  .photo-3,
  .photo-4,
  .photo-5 {
    grid-row: span 5;
  }
}

// testimonials

.testimonials {
  background-color: #ecf5ff;
  box-shadow: inset 0 0 12px 0 rgba(0, 0, 0, 0.1);

  h2 {
    text-align: center;
  }

  .owl-carousel {
    max-width: 800px;
    margin: 0 auto;
  }

  img {
    width: 120px !important;
    height: 120px;
    border: 4px solid #fff;
    border-radius: 50%;
    margin: 0 0 20px 0;
    @media (min-width: 600px) {
      margin: 0 20px 0 0;
    }
  }

  .flex-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
    @media (min-width: 600px) {
      flex-direction: row;
      align-items: flex-start;
      text-align: start;
    }

    h2 {
      font-size: 20px;
      color: #111;
      margin: 0 0 8px 0;
      @media (min-width: 600px) {
        text-align: start;
      }
    }

    h4 {
      font-weight: 300;
      margin: 0 0 8px 0;
      color: #999;
      font-size: 14px;
    }

    p {
      font-family: sans-serif;
      font-weight: 400;
      font-style: italic;
      color: #444;
    }
  }
}

// team

.team {
  h2 {
    text-align: center;
  }

  .flex-row {
    gap: 32px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .col {
    position: relative;
    flex-basis: 80%;
    @media (min-width: 600px) {
      flex-basis: 43%;
    }
    @media (min-width: 900px) {
      flex-basis: 21%;
    }

    &:hover {
      .bg {
        background-color: rgba(0, 123, 255, 0.5);
      }

      .info {
        margin-top: 0;
        opacity: 1;
      }
    }
  }

  img {
    display: block;
    width: 100%;
    border-radius: 50%;
  }

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    border-radius: 50%;
    transition: 500ms ease all;
  }

  .info {
    transition: 500ms ease all;
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    color: #fff;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;

    p:nth-child(1) {
      margin-bottom: 8px;
      font-weight: 700;
    }

    p:nth-child(2) {
      font-size: 12px;
      font-style: italic;
    }
  }
}

// Clients

.clients {
  background-color: #ecf5ff;
  box-shadow: inset 0 0 12px 0 rgba(0, 0, 0, 0.1);

  h2 {
    text-align: center;
  }

  .flex-row {
    flex-wrap: wrap;
  }

  .col {
    max-height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #d6eaff;
    border-right: 1px solid #d6eaff;
    border-left: 1px solid #d6eaff;
    background-color: #fff;
    padding: 64px;
    flex-basis: 100%;
    @media (min-width: 500px) {
      border-left: none;
      flex-basis: 50%;
    }
    @media (min-width: 900px) {
      flex-basis: 25%;
    }

    &:hover {
      img {
        transform: scale(1.2);
      }
    }

    img {
      max-width: 100%;
      height: auto;
      transition: 500ms ease all;
    }
  }

  .col:nth-child(1) {
    border-top: 1px solid #d6eaff;
  }

  .col:nth-child(2) {
    @media (min-width: 500px) {
      border-top: 1px solid #d6eaff;
    }
  }

  .col:nth-child(odd) {
    @media (min-width: 500px) {
      border-left: 1px solid #d6eaff;
    }
    @media (min-width: 900px) {
      border-left: none;
    }
  }

  .col:nth-child(3),
  .col:nth-child(4) {
    @media (min-width: 900px) {
      border-top: 1px solid #d6eaff;
    }
  }

  .col:nth-child(1),
  .col:nth-child(5) {
    @media (min-width: 900px) {
      border-left: 1px solid #d6eaff;
    }
  }
}

// Contact Us

.contact-us {
  h2,
  p {
    text-align: center;
  }

  p {
    margin-bottom: 60px;
  }

  input,
  button {
    display: block;
  }

  input,
  textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ced4da;

    &:focus {
      outline: none;
    }
  }

  input {
    margin-bottom: 16px;
  }

  textarea {
    height: 100%;
    resize: none;
  }

  form {
    max-width: 700px;
    margin: 0 auto;
  }

  .flex-row {
    flex-direction: column;
    @media (min-width: 500px) {
      flex-direction: row;
      gap: 32px;
    }
  }

  .btn {
    margin-top: 16px;
    font-weight: 400;
    &:hover {
      color: #007bff;
      border-color: #007bff;
    }
  }
}

// Footer

footer {
  color: #fff;
  background-color: #004a99;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ul {
    margin-bottom: 32px;
    flex-wrap: wrap;
    justify-content: center;
  }

  li {
    padding: 0 15px;
    margin-bottom: 16px;
  }

  a {
    font-size: 14px;
    font-weight: 500;
    color: #fff;
  }

  i {
    cursor: pointer;
    font-size: 30px;
  }

  p {
    text-align: center;
  }
}

// utility classes
.container {
  max-width: 1140px;
  margin: 0 auto;
}

.display-none {
  display: none;
}

.flex-row {
  display: flex;
}

.grid {
  display: grid;
}

.btn {
  cursor: pointer;
  display: inline-block;
  padding: 14px 40px;
  background-color: #007bff;
  color: #fff;
  border-radius: 45px;
  border: 2px solid transparent;
  font-weight: 600;
  transition: 500ms ease all;

  &:hover {
    background-color: transparent;
    border-color: #fff;
  }
}

.btn-light {
  background-color: transparent;
  border-color: #fff;

  &:hover {
    background-color: #007bff;
    border-color: transparent;
  }
}

.pink-text {
  color: #ff689b;
}

.yellow-text {
  color: #e9bf06;
}

.teal-text {
  color: #3fcdc7;
}

.green-text {
  color: #41cf2e;
}

.limeGreen-text {
  color: #d6ff22;
}

.blue-text {
  color: #4680ff;
}
</style>
